import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { checkOutAction, packageAction } from "../../redux/action";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import moment from "moment";
import SeoAdd from "../Seo/SeoAdd";
import DatePicker from "react-datepicker";
import { onlyNumber } from "../../constant/utils";
import { validateHomeCollection } from "../../constant/validation";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import WhyOncq from "../../Home/component/WhyOncq";
import HomeCollTandC from "../../Component/HomeCollectionForm/HomeCollTandC";
import SeoHeaderContent from "../Seo/SeoHeaderContent";

const initialValue = {
  FirstName: "",
  LastName: "",
  Mobile: "",
  EmailId: "",
  CityId: "",
  PreferredDate: null,
  PreferredTime: "",
  PackageId: "",
  Address: "",
  Other: "",
  UtmSource: "",
  UtmMedium: "",
  UtmCampaign: "",
  Checkbox: false,
};

function HomeCollectionForm() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const datepickerRef = useRef(null);
  const cityData = useSelector((state: any) => state.dashboard.cityAll);
  const packageDt: any = useSelector((state: any) => state.package.list?.Packages);
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const seoData: any = useSelector((state: any) => state.dashboard.seoDetail?.Details);

  useEffect(() => {
    window?.scrollTo(0, 0);
    dispatch(packageAction.listPackageAction({}));
  }, []);

  const handleSubmit = (values: any) => {
    let newDt: any = {};
    newDt.Checkbox = values?.Checkbox;
    newDt.MobileNo = values?.Mobile;
    newDt.PatientFirstName = values?.FirstName;
    newDt.PatientLastName = values?.LastName;
    newDt.PatientGender = null;
    newDt.PatientMobile = values?.Mobile;
    newDt.CustomerName = `${values?.FirstName} ${values?.LastName}`;
    newDt.CustomerEmail = values?.EmailId;
    newDt.CustomerAddressLine1 = values?.Address;
    newDt.CustomerCityId = values?.CityId;
    newDt.ItemId = values?.PackageId;
    newDt.ItemType = "package";
    newDt.ScheduleDate = values?.PreferredDate && moment(values?.PreferredDate).format("YYYY-MM-DD");
    newDt.ScheduleTime = values?.PreferredTime && moment(values?.PreferredTime, ["HH:mm"]).format("h:mm:ss");
    newDt.SourceUrl = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    newDt.UtmSource = urlParams.get("utm_source");
    newDt.UtmMedium = urlParams.get("utm_medium");
    newDt.UtmCampaign = urlParams.get("utm_campaign");
    newDt.transactionId = sessionStorage.getItem("da_transaction_id") || "";




    setButtonDisabled(true);
    dispatch(
      checkOutAction.createHomeCollectionAction(
        newDt,
        history,
        () => setButtonDisabled(false),
        () => setButtonDisabled(false)
      )
    );
  };
  function handleClickDatepickerIcon() {
    const datepickerElement: any = datepickerRef?.current;
    datepickerElement?.setFocus(true);
  }
  return (
    <>
      <SeoAdd slug={ROUTE.HOMECOLLECTION} />
      <BreadCrumb page={t("query_form")} data={{ slug: "", path: "" }} />
      <section
        className="thank-section prescription-bottom home-pre-bott"
        style={{ backgroundImage: "url(/assets/img/home_collection.png)" }}
      >
        {/* <img className="scale d-none d-md-block" src="/assets/img/home_collection.png" alt="" /> */}
        <div className="container">
          <div className="tab-content">
            <div id="organs" className="tab-pane fade in active show">
              <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-4">
                  <div className="h-services">
                    <Formik
                      initialValues={initialValue}
                      enableReinitialize={true}
                      validationSchema={validateHomeCollection}
                      onSubmit={(val: any) => {
                        handleSubmit(val);
                      }}
                      render={({ values, handleChange, errors, touched, handleBlur, handleSubmit, setFieldValue }) => (
                        <form onSubmit={handleSubmit}>
                          <div className="infobox_wrapper">
                            <h4 className="mr-10">{t("query_form")}</h4>
                            <div className="ln-1 mr-10">
                              {t("query_form_content1")}
                              <br />
                            </div>
                            <div className="form-group">
                              <input
                                type="text"
                                name="FirstName"
                                className="form-control"
                                placeholder={t("first_name")}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values?.FirstName}
                              />
                              {touched?.FirstName && errors?.FirstName && (
                                <span className="error_message">{t(errors?.FirstName as string)}</span>
                              )}
                            </div>
                            <div className="form-group">
                              <input
                                type="text"
                                name="LastName"
                                className="form-control"
                                placeholder={t("last_name")}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values?.LastName}
                              />
                              {touched?.LastName && errors?.LastName && (
                                <span className="error_message">{errors?.LastName}</span>
                              )}
                            </div>
                            <div className="form-group">
                              <input
                                type="text"
                                name="Mobile"
                                className="form-control"
                                placeholder={t("mobile_number")}
                                onKeyPress={onlyNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values?.Mobile}
                              />
                              {touched?.Mobile && errors?.Mobile && (
                                <span className="error_message">{t(errors?.Mobile as string)}</span>
                              )}
                            </div>
                            <div className="form-group">
                              <input
                                type="text"
                                name="EmailId"
                                className="form-control"
                                placeholder={t("email")}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values?.EmailId}
                              />
                              {touched?.EmailId && errors?.EmailId && (
                                <span className="error_message">{t(errors?.EmailId as string)}</span>
                              )}
                            </div>
                            <div className="form-group">
                              <select
                                className="form-control"
                                name="CityId"
                                id="CityId"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.CityId}
                              >
                                <option value="">{t("city-with*")}</option>
                                {cityData &&
                                  cityData.length > 0 &&
                                  cityData?.map((item: any, i: any) => (
                                    <option className="text-uppercase" value={item?.Id} key={i}>
                                      {t(item?.Name)}
                                    </option>
                                  ))}
                              </select>
                              {touched?.CityId && errors?.CityId && (
                                <span className="error_message">{t(errors?.CityId as string)}</span>
                              )}
                            </div>
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                placeholder={t("address")}
                                name="Address"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values?.Address}
                              />
                              {/* {touched?.Address && errors?.Address && <span className="error_message">{errors?.Address}</span>} */}
                            </div>
                            <div className="form-group">
                              <div className="dt_picker">
                                <DatePicker
                                  ref={datepickerRef}
                                  selected={values?.PreferredDate}
                                  className="form-control"
                                  onChange={(value: any) => value && setFieldValue("PreferredDate", value)}
                                  minDate={new Date()}
                                  dateFormat="dd-MM-yyyy"
                                  showMonthDropdown
                                  showYearDropdown
                                  peekNextMonth
                                  dropdownMode="select"
                                  placeholderText={t("preferred_date*")}
                                  onChangeRaw={(e: any) => e.preventDefault()}
                                />
                                <span>
                                  <img
                                    className="scale"
                                    src="/assets/img/age.png"
                                    alt=""
                                    onClick={() => handleClickDatepickerIcon()}
                                  />
                                </span>
                              </div>
                              {touched?.PreferredDate && errors?.PreferredDate && (
                                <span className="error_message">{t(errors?.PreferredDate as string)}</span>
                              )}
                            </div>
                            <div className="form-group">
                              <div className="input-group date" id="datetimepicker3">
                                <input
                                  type="time"
                                  className="form-control"
                                  placeholder="PreferredTime"
                                  name="PreferredTime"
                                  value={values?.PreferredTime}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                              </div>
                              {touched?.PreferredTime && errors?.PreferredTime && (
                                <span className="error_message">{t(errors?.PreferredTime as string)}</span>
                              )}
                            </div>
                            <div className="form-group">
                              <select
                                className="form-control"
                                name="PackageId"
                                id="PackageId"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.PackageId}
                              >
                                <option value="">{t("select_package")}</option>
                                {packageDt &&
                                  packageDt.length > 0 &&
                                  packageDt?.map((item: any, i: any) => (
                                    <option className="text-uppercase" value={item?.Id} key={i}>
                                      {t(item?.PackageName)}
                                    </option>
                                  ))}
                              </select>
                              {/* {touched?.PackageId && errors?.PackageId && <span className="error_message">{errors?.PackageId}</span>} */}
                            </div>
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                placeholder={t("other")}
                                name="Other"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values?.Other}
                              />
                            </div>
                            {/* <div className="d-flex for-check-style">
                              <input
                                type="checkbox"
                                name="Checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                id="checkbox_id"
                              />
                              <label className="mx-2" htmlFor="checkbox_id">
                                By clicking you accept to the{" "}
                                <a className="text-info" href="https://oncquestlabs.com/terms-condition">
                                  terms and conditions
                                </a>{" "}
                                and the{" "}
                                <a className="text-info" href="https://oncquestlabs.com/privacy-policy">
                                  Privacy Policy.
                                </a>
                              </label>
                            </div> */}


                            <div className="d-flex for-check-style">
                              <input
                                type="checkbox"
                                name="Checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                id="checkbox_id"
                              />
                              {/* <label className="mx-2" htmlFor="checkbox_id">
                                By clicking you accept to the{" "}
                                <a className="text-info" href="https://oncquestlabs.com/terms-condition">
                                  terms and conditions
                                </a>{" "}
                                and the{" "}
                                <a className="text-info" href="https://oncquestlabs.com/privacy-policy">
                                  Privacy Policy.
                                </a>
                              </label> */}
                              <label className="mx-2" htmlFor="checkbox_id">
                               I consent to the collection and processing of my personal data for scheduling and managing my home sample collection appointment.
  
                              </label>
                            </div>
                            <div>
                              {touched?.Checkbox && errors?.Checkbox && (
                                <span className="error_message">{errors?.Checkbox}</span>
                              )}
                            </div>
                            <button type="submit" disabled={isButtonDisabled} className="book--hexagon active">
                              <span>
                                {t("submit_btn")}
                                <i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i>
                              </span>
                            </button>
                            <div className="f-10"> {t("query_form_content2")}</div>
                            <div className="f-10">
                              {" "}
                              *Free Home visit only applicable for price above <strong> Rs. 1500</strong>
                            </div>
                            <div className="f-10">{t("query_form_note")}</div>
                          </div>
                        </form>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="home-coll-whyonc pt-3">
        {seoData?.HeaderContent && (
          <section className="pathlogy-content">
            <div className="container">
              <div className="bg-package imp-instruction col-md-12 p-4 mb-3">
                <SeoHeaderContent />
              </div>
            </div>
          </section>
        )}
        <HomeCollTandC />
        <WhyOncq />
      </div>
    </>
  );
}

export default HomeCollectionForm;
